import {useTranslation} from "react-i18next";
import "./Blog.css"
import {useCallback, useEffect, useState} from "react";
import {useParams} from "react-router";
import {BlogData, blogsData, useData} from "../../components/hooks/recoilData";
import {useRecoilState} from "recoil";

export const Blog = () => {
    const {t} = useTranslation();
    const {id} = useParams();
    const [updateBlogs] = useData();
    updateBlogs();
    const [blogs,] = useRecoilState(blogsData);
    const [blog, setBlog] = useState<BlogData>();
    const htmlDefault = "<p>no content</p>";
    const [htmlContent, setHtmlContent] = useState(htmlDefault);

    /**
     * Обрабатывает HTML-строку: дублирует CSS-ссылки из head в начало body
     * и добавляет префикс "/blog/" ко всем относительным ссылкам (link и a).
     */
    const processHtml = useCallback((html: string): string => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Проверка, является ли URL относительным
        const isRelative = (url: string): boolean => {
            // Не начинается с протокола (http://, https://, //) и не с "/"
            return !/^([a-z]+:)?\/\//i.test(url) && !url.startsWith('/');
        };

        // Добавляет префикс "/blog/" к относительному URL
        const addBlogPrefix = (url: string): string => {
            if (!isRelative(url)) return url;
            if (url.startsWith("./"))
                url = url.substring(2);
            if (url.startsWith("../"))
                url = url.substring(3);
            if (url.endsWith(".html")) {
                let urlL = url.substring(0, url.length - 5);
                const blogV = blogs.find(blog => blog.link === urlL);
                if (blogV)
                    return `/#/blog/${urlL}`;
            }
            return `/blog/${url}`;
        };

        // 1. Находим все <link rel="stylesheet"> внутри <head>
        const headLinks = doc.querySelectorAll<HTMLLinkElement>(
            'head link[rel="stylesheet"]'
        );
        const body = doc.body;

        // 2. Дублируем каждый такой link в начало <body>
        headLinks.forEach((link) => {
            // const originalHref = link.getAttribute('href');
            // if (!originalHref) return;

            // Клонируем элемент и изменяем href
            const newLink = link.cloneNode(true) as HTMLLinkElement;
            // newLink.setAttribute('href', addBlogPrefix(originalHref));

            // Вставляем в начало body (перед первым дочерним элементом)
            body.insertBefore(newLink, body.firstChild);
        });

        // 3. Для всех <link> и <a> в документе (включая только что добавленные)
        //    заменяем относительные href на абсолютные с префиксом "/blog/"
        const allLinksAndAnchors = doc.querySelectorAll<HTMLElement>('link, a');
        allLinksAndAnchors.forEach((el) => {
            const href = el.getAttribute('href');
            if (href)
                el.setAttribute('href', addBlogPrefix(href));
        });

        // Возвращаем только содержимое <body> для вставки
        let text = body.innerHTML;

        let strId = text.indexOf("<body>");
        if (strId !== -1)
            text = "<html>" + text.substring(strId);
        return text;
    }, [blogs]);

    useEffect(() => {
        // const idV = id ? parseInt(id) : 1;
        const blogV = blogs.find(blog => blog.link === id/*idV*/);
        if (blogV) {
            setBlog(prev => {
                if (!blogV || prev === blogV)
                    return prev;
                fetch(blogV.contentUrl.replace("http://www.shelfmc.ru/", "/"))
                    .then(response => {
                        if (!response.ok)
                            throw new Error('Network response was not ok');
                        return response.text();
                    })
                    .then((rawHtml) => setHtmlContent(processHtml(rawHtml)))
                    .catch(error => console.error('Error fetching data:', error));
                return blogV;
            });
        }
    }, [id, blogs, processHtml]);

    return (
        <div className="main-container pt-2">
            <section>
                <p className="text-center animated">{t('blog.2.1')}</p>
                <h3 className="text-center animated">{blog ? blog.title : ""}</h3>
                <div className="blog" dangerouslySetInnerHTML={{__html: htmlContent}}/>
            </section>
        </div>
    );
};